"use client";

interface VisitorBootstrapSnapshot {
	sqid: string;
	traitsForPosthog: Record<string, unknown>;
}

let latestVisitorBootstrap: VisitorBootstrapSnapshot | null = null;

export function setVisitorBootstrapSnapshot(
	snapshot: VisitorBootstrapSnapshot,
): void {
	latestVisitorBootstrap = snapshot;
}

export function readVisitorBootstrapSnapshot(
	sqid: string,
): Record<string, unknown> | null {
	if (latestVisitorBootstrap?.sqid !== sqid.trim()) {
		return null;
	}
	return latestVisitorBootstrap.traitsForPosthog;
}

export function clearVisitorBootstrapSnapshot(): void {
	latestVisitorBootstrap = null;
}
